import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=5b01577c"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b01577c')) {
      api.createRecord('5b01577c', component.options)
    } else {
      api.reload('5b01577c', component.options)
    }
    module.hot.accept("./AppLayout.vue?vue&type=template&id=5b01577c", function () {
      api.rerender('5b01577c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/AppLayout.vue"
export default component.exports